module.exports = __webpack_public_path__ + "img/planet-uranus.16ea7303.webp";